import { ArrowRight, Calendar, Filter, Search } from "react-feather";
import styles from "./logfilter.module.css";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import { useMemo, useState } from "react";
import FilterAutocomplete from "../../../../components/FilterAutocomplete";

const TYPE_OPTIONS = [
    { value: "Prospect", label: "Prospect" },
    { value: "Tenant", label: "Tenant" },
    { value: "Contact", label: "Contact" },
];

const LogFilter = ({ filterData, setFilterData, campaignList }) => {
    const [filterOpen, setFilterOpen] = useState(false);

    const campaignOptions = useMemo(() => {
        return (campaignList || []).filter(item => item?.is_archived === 0 && item?.is_deleted === 0).map(item => {
            return { value: item?.id, label: item?.title };
        });
    }, [campaignList]);

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" value={filterData?.searchKey || ""} onChange={(e) => setFilterData(prev => {
                    return { ...prev, searchKey: e.target.value };
                })} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Type"
                        options={TYPE_OPTIONS}
                        value={filterData?.type}
                        onChange={(value) => setFilterData(prev => {
                            return { ...prev, type: value };
                        })}
                    />
                </div>
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
                    <FilterAutocomplete
                        label="Campaigns"
                        options={campaignOptions}
                        value={filterData?.campaign}
                        noOptionsText="No campaigns"
                        onChange={(value) => setFilterData(prev => {
                            return { ...prev, campaign: value };
                        })}
                    />
                </div>
                <div className={`${styles.FilterCard}`}>
                    <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
                        <DateRangePicker
                            format={"M/d/yy"}
                            placeholder={"Filter by date"}
                            placement={"bottomEnd"}
                            caretAs={Calendar}
                            showOneCalendar
                            value={filterData?.submitted || null}
                            onChange={(e) => {
                                setFilterData(prev => {
                                    return { ...prev, submitted: e };
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
        </div>
    </div>)
}

export default LogFilter;